import { storage, isSupported } from 'local-storage-fallback';

export const customLocalStorage = isSupported('localStorage') ? window.localStorage : storage;
